export default function isValidLineManager(lineManager) {
  return Boolean(lineManager?.user_id && lineManager?.email?.trim());
}
